export default {"src":"/_next/static/media/profile_icon_dart.401a92d7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};